var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M742.4 153.6h102.4a25.6 25.6 0 0 1 0-51.2h51.2a25.6 25.6 0 0 1 0 51.2H358.4v614.4a51.2 51.2 0 0 0 51.2 51.2h233.6256a102.4 102.4 0 1 1 0 51.2H396.8C347.3408 870.4 307.2 824.576 307.2 768V153.6H128a25.6 25.6 0 0 1 0-51.2h614.4a25.6 25.6 0 0 1 0 51.2z m-99.1744 307.2a102.4 102.4 0 1 1 0 51.2H358.4V460.8h284.8256z m99.1744 76.8a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4z m0 358.4a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector-2.42de5f44.svg";
export { ForwardRef as ReactComponent };